import { useRef } from "react";
import Shepherd from "shepherd.js";
import "shepherd.js/dist/css/shepherd.css";

import { TOUR_OPTIONS } from "constants/tourGuiado";
import { adicionarPassosTour, listarTopicosTour } from "utils";

export const useGuidedTour = (steps = [], options) => {
  const tourRef = useRef(null);

  const build = () => {
    if (tourRef.current) {
      try {
        tourRef.current.complete();
      } catch {
        /* noop */
      }
    }
    const tour = new Shepherd.Tour({ ...TOUR_OPTIONS, ...options });
    adicionarPassosTour(tour, steps);
    tourRef.current = tour;
    return tour;
  };

  const start = () => build().start();

  const show = id => {
    const tour = build();
    tour.start();
    tour.show(id);
  };

  return { start, show, topics: listarTopicosTour(steps) };
};
